module.exports = "/images/vendor/vue-paycard/src/15.jpg?9cb21606e25d4592618461eb2bb47634";